export const APP_NAME = 'Flirtify';
export const APP_SITE = 'Flirtify.com';
export const MINUTE_IN_SECONDS = 60;
export const MINUTE_IN_MS = MINUTE_IN_SECONDS * 1000;
export const HALF_MINUTE_IN_MS = MINUTE_IN_MS / 2;
export const HOUR_IN_SECONDS = 60 * MINUTE_IN_SECONDS;
export const HOUR_IN_MS = HOUR_IN_SECONDS * 1000;
export const DAY_IN_SECONDS = 24 * HOUR_IN_SECONDS;
export const DAY_IN_MS = 24 * HOUR_IN_SECONDS * 1000;
export const MONTH_IN_SECONDS = 30 * DAY_IN_SECONDS;
export const YEAR_IN_SECONDS = 12 * MONTH_IN_SECONDS;

export const YEAR_IN_MS = YEAR_IN_SECONDS * 1000;
export const MONTH_IN_MS = MONTH_IN_SECONDS * 1000;

export const THIRTY_DAYS_IN_MS = DAY_IN_MS * 30;
export const QUARTER_HOUR_IN_MS = MINUTE_IN_MS * 15;

export const DISPLAY_NAME_REGEX = /^[\x00-\x7Fа-яА-ЯёЁ]*$/;
export const DISPLAY_NAME_FALLBACK_REGEX = /^ID: \d+$/;
export const USERNAME_FORBIDDEN_REGEX = /[^a-zA-Z0-9_-]/;
export const LOWERCASE_REGEX = /[a-z]/;
export const UPPERCASE_REGEX = /[A-Z]/;
export const DIGITS_REGEX = /[0-9]/;
export const SPECIAL_CHARS_REGEX = /[!@#$%^&*]/;
export const EMAIL_WITHOUT_PLUS_REGEX = /^([a-zA-Z0-9])[a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/u;
export const EMAIL_REGEX = /^([a-zA-Z0-9])[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/u;
export const DOMAIN_REGEXP =  /^[a-zA-Z0-9](?:[a-zA-Z0-9\-]*[a-zA-Z0-9])?$/;
export const DOMAIN_2LEVEL_REGEXP = /^[a-zA-Z0-9._-]+(\.[a-zA-Z0-9._-]+)*$/;

export const LINK_REGEX = /(?:https?:\/\/)?(?:www\.)?([a-zA-Z0-9\u4e00-\u9fa5\u3400-\u4DBF\u20000-\u2A6DF\u2A700-\u2B73F\u2B740-\u2B81F\u2B820-\u2CEAF\u2CEB0-\u2EBEF\u2F800-\u2FA1F-]+\.){1,3}[a-zA-Z\u4e00-\u9fa5\u3400-\u4DBF\u20000-\u2A6DF\u2A700-\u2B73F\u2B740-\u2B81F\u2B820-\u2CEAF\u2CEB0-\u2EBEF\u2F800-\u2FA1F-]{2,}(?:\.[a-zA-Z\u4e00-\u9fa5\u3400-\u4DBF\u20000-\u2A6DF\u2A700-\u2B73F\u2B740-\u2B81F\u2B820-\u2CEAF\u2CEB0-\u2EBEF\u2F800-\u2FA1F-]{2,})?(\/[^\s]*)?(?:\?([^#\s]*))?/g;

export const DISPLAY_NAME_LENGTH_MIN = 4;
export const DISPLAY_NAME_LENGTH_MAX = 20;

export const PASSWORD_LENGTH_MIN = 8;
export const PASSWORD_LENGTH_MAX = 30;

export const EMAIL_LENGTH_MIN = 6;
export const EMAIL_LENGTH_MAX = 50;

export const FULL_LEGAL_NAME_MAX = 500;

export const DEFAULT_TEXT_MAX = 1000;

export const MAX_SPEAK_LANG = 6;
export const MAX_INTERESTS_COUNT = 20;

export const USER_NOTES_LENGTH_MAX = 2000;

export const PLAYER_APP_KEY = 'flirtify';

export const USER_PING_TIMEOUT_S = 5;
export const USER_PING_TIMEOUT_MS = USER_PING_TIMEOUT_S * 1000;
// add ping_timeout_space because sometimes ping comes to the server with some delay
// due to transport (websockets and internet speed)
export const USER_PING_TIMEOUT_SPACE_S = 3;
export const USER_PING_TIMEOUT_PARTNER_SPACE_S = 5;
export const USER_PING_TIMEOUT_SPACE_MS = USER_PING_TIMEOUT_SPACE_S * 1000;
export const USER_OFFLINE_TIMEOUT_S = 30;
export const PARTNER_LEFT_TIMEOUT_S = 10;
export const USER_OFFLINE_TIMEOUT_MS = USER_OFFLINE_TIMEOUT_S * 1000;
export const PARTNER_LEFT_TIMEOUT_MS = PARTNER_LEFT_TIMEOUT_S * 1000;
export const OFFLINE_PARTNER_TIMEOUT_MS = 20 * 1000;

export const USER_TIMEOUT_S = 2 * USER_PING_TIMEOUT_S;
export const USER_TIMEOUT_MS = 2 * USER_PING_TIMEOUT_MS;
export const USER_TIMEOUT_ROOM_MS = 2 * USER_PING_TIMEOUT_MS;
export const TIMEOUT_ROOM_MS = 5 * MINUTE_IN_MS;
export const OFFLINE_ROOM_MS = 30 * 1000;

export const USER_MINUTES_BOUNDARY = 2;

export const ML_SERVICES_ERROR_REQS_MAX = 10;

export const NOTE_MAX_LENGTH = 500;
export const STATS_ID_MAX_VAL = 1_000_000;